/**
 * <SuggestedFollowUps /> — clickable follow-up chips (M25.5).
 *
 * After an assistant turn finishes, a lightweight Haiku call
 * proposes 2-3 follow-up questions; they render here as chips.
 * Clicking one sends it as the next message — it goes through the
 * normal orchestrator (and its permission checks), so a chip is
 * never a shortcut around anything.
 */

import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface SuggestedFollowUpsProps {
  followUps: string[];
  onPick: (text: string) => void;
}

export function SuggestedFollowUps({
  followUps,
  onPick,
}: SuggestedFollowUpsProps) {
  const { t } = useTranslation();
  if (followUps.length === 0) return null;
  return (
    <div
      className="flex flex-wrap gap-1.5 pt-0.5"
      aria-label={t("app.sf_aria")}
    >
      {followUps.map((q, i) => (
        <button
          key={`${q}-${i}`}
          type="button"
          onClick={() => onPick(q)}
          className="inline-flex items-center gap-1 rounded-full border border-ai-subtle bg-ai-bg px-2 py-0.5 text-xs text-brand-blue hover:bg-surface-sunken"
        >
          <Sparkles
            size={9}
            className="shrink-0 text-brand-teal"
            aria-hidden="true"
          />
          {q}
        </button>
      ))}
    </div>
  );
}
